(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["press-review-section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const wrapper = document.querySelector('.press-review-section__wrapper');
    
    if (!wrapper) return;
    
    let isDown = false;
    let startX;
    let scrollLeft;

    wrapper.addEventListener('mousedown', (e) => {
      isDown = true;
      wrapper.style.cursor = 'grabbing';
      startX = e.pageX - wrapper.offsetLeft;
      scrollLeft = wrapper.scrollLeft;
    });

    wrapper.addEventListener('mouseleave', () => {
      isDown = false;
      wrapper.style.cursor = 'grab';
    });

    wrapper.addEventListener('mouseup', () => {
      isDown = false;
      wrapper.style.cursor = 'grab';
    });

    wrapper.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - wrapper.offsetLeft;
      const walk = (x - startX) * 2;
      wrapper.scrollLeft = scrollLeft - walk;
    });

    // Prevent click event when dragging
    const cards = wrapper.querySelectorAll('.press-review-section__card');
    cards.forEach(card => {
      card.addEventListener('click', (e) => {
        if (wrapper.dataset.dragging === 'true') {
          e.preventDefault();
        }
      });
    });

    wrapper.addEventListener('mousedown', () => {
      wrapper.dataset.dragging = 'false';
    });

    wrapper.addEventListener('mousemove', () => {
      if (isDown) {
        wrapper.dataset.dragging = 'true';
      }
    });

    wrapper.addEventListener('mouseup', () => {
      setTimeout(() => {
        wrapper.dataset.dragging = 'false';
      }, 10);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["q-logos"] && !Shopify.designMode) return;
  try {
    
  if (!window.customElements.get('q-logos-marquee')) {
    class QLogosMarquee extends HTMLElement {
      constructor() {
        super();
        this._update = this._update.bind(this);
        this._copies = 0;

        if (window.ResizeObserver) {
          this._observer = new ResizeObserver(this._update);
          this._observer.observe(this);
        }

        this._update();
      }

      disconnectedCallback() {
        this._observer?.disconnect();
      }

      _getSeedMarkup() {
        if (!this._seedMarkup) {
          const seed = this.querySelector('[data-q-logos-seed]');
          if (!seed) return '';
          this._seedMarkup = seed.outerHTML.replace(/\s*data-q-logos-seed=""/, '');
        }

        return this._seedMarkup;
      }

      _rebuildTrack() {
        const track = this.querySelector('.q-logos__track');
        const seedMarkup = this._getSeedMarkup();

        if (!track || !seedMarkup) {
          return null;
        }

        const measure = document.createElement('div');
        measure.style.cssText = 'position:absolute;visibility:hidden;pointer-events:none;height:0;overflow:hidden;';
        measure.innerHTML = seedMarkup;
        this.append(measure);

        const segment = measure.querySelector('.q-logos__content');
        const segmentWidth = segment?.offsetWidth || 0;
        measure.remove();

        if (segmentWidth <= 0) {
          return null;
        }

        const viewport = this.clientWidth || window.innerWidth;
        const copies = Math.min(20, Math.max(2, Math.ceil((viewport + segmentWidth) / segmentWidth)));

        if (copies !== this._copies) {
          track.innerHTML = '';

          for (let index = 0; index < copies; index += 1) {
            track.insertAdjacentHTML('beforeend', seedMarkup);
            const content = track.lastElementChild;

            if (index > 0) {
              content.setAttribute('aria-hidden', 'true');
            }
          }

          this._copies = copies;
          this.style.setProperty('--q-logos-copies', copies);
        }

        return track.querySelector('.q-logos__content');
      }

      _update() {
        const speed = parseFloat(this.getAttribute('scrolling-speed')) || 15;
        const content = this._rebuildTrack();

        if (!content || speed <= 0) {
          return;
        }

        const duration = content.offsetWidth / speed;
        this.style.setProperty('--marquee-animation-duration', `${Math.max(duration, 8)}s`);

        this.querySelectorAll('.q-logos__image').forEach((image) => {
          if (!image.complete) {
            image.addEventListener('load', this._update, { once: true });
          }
        });
      }
    }

    window.customElements.define('q-logos-marquee', QLogosMarquee);
  }

  } catch(e) { console.error(e); }
})();
})();
